// Tiny leaf module holding the React context for the active
// CopilotController. Kept separate from CopilotRuntimeProvider so consumers
// (e.g. CodeBlock) can subscribe without dragging in @assistant-ui/react,
// which is ESM-only and breaks Jest under CRA-5.

import { createContext, useContext } from "react";

export const CopilotControllerContext = createContext(null);

export function useCopilotController() {
  const c = useContext(CopilotControllerContext);
  if (!c) throw new Error("useCopilotController must be called inside <CopilotRuntimeProvider>");
  return c;
}
